import * as React from 'react';
import { Box, Group, Button, Select, SelectItem } from '@mantine/core';
import  { useForm, isNotEmpty } from "@mantine/form";
import axios from 'axios';
import type { IResponse } from "../../types/api";
import { useNavigate } from "react-router-dom";
import { CLIENT_ROUTE, API_ROUTE, CLIENT_TITLE } from "./constants";
import { showMessage } from "../../lib/notification";
import type { IUserSubscription } from "./types";
import SearchableSelect from "../../components/common/SearchableSelect";
import { IconChevronDown } from "@tabler/icons-react";
import { IListResponse } from "../../types/api";
import { ISubscriptionRecord } from "../subscriptions/List";
import Page from "../../components/layout/Page";
import { useFormStyles } from "../../styles/form";
interface FormValues extends Pick<IUserSubscription, 'userId' | 'subscriptionId'> {
}

interface IUserItem {
    _id: string;
    customerId: string;
    email: string;
    isActive: boolean;
    isDeleted: boolean;
}

const CreateUserSubscription = () => {

    const { classes } = useFormStyles();
    const navigate = useNavigate();

    const hasFetchedRef = React.useRef(false);
    const [ subscriptions, setSubscriptions ] = React.useState<ISubscriptionRecord[]>([]);

    const form = useForm<FormValues>({
        initialValues: {
            userId: '',
            subscriptionId: ''
        },

        validate: {
            userId: isNotEmpty('Хэрэглэгч сонгоно уу'),
            subscriptionId: isNotEmpty('Багц сонгоно уу'),
        },
    });

    const parser = (user: IUserItem) => {
        return {
            value: user._id,
            label: `${user.customerId} - ${user.email}`,
        }
    }

    const subscriptionsData: SelectItem[] = React.useMemo(() => {
        return subscriptions.map((subscription) => {
            return {
                value: subscription._id,
                label: `${subscription.title} - ${subscription.priceText}`
            }
        })
    }, [subscriptions]);

    const handleDropdownOpen = async () => {
        if (!hasFetchedRef.current) {
            const { data } = await axios.get<IListResponse<ISubscriptionRecord>>('/api/subscription');
            setSubscriptions(data?.result?.docs ?? []);
        }
    }

    const handleSubmit = async (values: FormValues) => {
        const { data } = await axios.post<IResponse<any>>(API_ROUTE, values);
        if (data.statusCode === 200) {
            navigate(CLIENT_ROUTE);
            showMessage('Амжилттай', 'green');
        } else {
            showMessage('Алдаа гарлаа');
        }
    };

    return (
        <Page>
            <Page.Header title={`${CLIENT_TITLE} үүсгэх`} backRoute={CLIENT_ROUTE}/>
            <Page.Body>
                <Box sx={{ maxWidth: 500 }} mx="auto" my={'xl'}>
                    <form onSubmit={form.onSubmit(handleSubmit)} className={classes.form}>

                        <SearchableSelect<IUserItem>
                            uri={'/api/customer/search'}
                            parser={parser}
                            selectProps={{
                                label: 'Хэрэглэгч',
                                withAsterisk: true,
                                ...form.getInputProps('userId')
                            }}
                        />

                        <Select
                            label="Багц"
                            rightSection={<IconChevronDown size={14} />}
                            rightSectionWidth={30}
                            styles={{ rightSection: { pointerEvents: 'none' } }}
                            data={subscriptionsData}
                            onDropdownOpen={handleDropdownOpen}
                            placeholder={'Сонгох...'}
                            {...form.getInputProps('subscriptionId')}
                        />
                    </form>
                </Box>
            </Page.Body>
            <Page.Footer>
                <Group position="right" mt="md">
                    <Button color='color-secondary' onClick={() => form.onSubmit(handleSubmit)()}>Хадгалах</Button>
                </Group>
            </Page.Footer>
        </Page>
    );
};

export default CreateUserSubscription;